import axios from 'axios';

const apiClient = axios.create({ withCredentials: true });

export const isSessionExpired = (error) => (
  error?.response?.status === 403
  && ['NOT_AUTHORIZED', 'INVALID_TOKEN'].includes(error?.response?.data?.errorMessageKey)
);

apiClient.interceptors.response.use((response) => response, (error) => {
  if (isSessionExpired(error)) window.dispatchEvent(new Event('fleet-session-expired'));
  return Promise.reject(error);
});

export default apiClient;
